import React from 'react';
import { Dialog } from '@headlessui/react';

const Modal = ({ open, onClose, title, description, children, footer }) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto w-full max-w-sm rounded-xl border border-line bg-raised p-6 text-fg">
          {title && (
            <Dialog.Title className="text-lg font-medium tracking-head text-fg">
              {title}
            </Dialog.Title>
          )}
          {description && (
            <Dialog.Description className="mt-2 text-sm text-fg-3">
              {description}
            </Dialog.Description>
          )}
          <div className="mt-4">
            {children}
          </div>
          {footer && (
            <div className="mt-6">
              {footer}
            </div>
          )}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export { Modal };
